import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export { default as Button } from './Button.vue'
export { default as ButtonLoading } from './ButtonLoading.vue'

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground shadow hover:bg-primary-hover',
        destructive: 'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive-hover',
        outline: 'border border-input text-foreground bg-background shadow-sm hover:bg-accent hover:text-accent-foreground',
        'dora-outline': 'border border-input bg-background shadow-sm text-sky-400 border-sky-400 hover:bg-sky-950',
        outlineDestructive:
          'border border-destructive text-destructive bg-background shadow-sm hover:bg-destructive/10 hover:text-destructive-hover',
        secondary: 'border border-input text-primary bg-background shadow-sm hover:bg-accent hover:text-accent-foreground',
        ghost: 'hover:bg-accent hover:text-accent-foreground',
        'dora-ghost': 'text-primary bg-transparent hover:bg-accent',
        link: 'text-primary underline-offset-4 hover:underline hover:bg-transparent',
        internal: 'bg-internal text-primary-foreground shadow-sm hover:bg-internal/80',
        'internal-ghost': 'text-internal bg-transparent hover:bg-accent',
      },
      size: {
        default: 'h-10 px-4 py-2',
        xs: 'rounded-md px-1 py-1 text-xs',
        sm: 'h-9 rounded-md px-3 text-xs',
        lg: 'h-11 rounded-md px-8',
        icon: 'h-10 w-10',
        'icon-sm': 'h-7 w-7 p-1.5',
        'icon-xs': 'rounded-md text-xs p-1',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
